import { render, staticRenderFns } from "./FeedbackModal.vue?vue&type=template&id=707b9f5e&scoped=true&"
import script from "./FeedbackModal.vue?vue&type=script&lang=ts&"
export * from "./FeedbackModal.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackModal.vue?vue&type=style&index=0&id=707b9f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b9f5e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRating } from 'vuetify/lib/components/VRating';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VContainer,VDialog,VForm,VIcon,VRating,VRow,VSnackbar,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('707b9f5e')) {
      api.createRecord('707b9f5e', component.options)
    } else {
      api.reload('707b9f5e', component.options)
    }
    module.hot.accept("./FeedbackModal.vue?vue&type=template&id=707b9f5e&scoped=true&", function () {
      api.rerender('707b9f5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/feedbacks/components/FeedbackModal.vue"
export default component.exports